import React, { useState } from 'react';
import FormContainer, { styles } from '../../../forms/FormContainer/FormContainer';
import FileUpload from '../../../forms/FileUpload';
import { useFormik } from 'formik';
import * as yup from 'yup';
import FormField from '../../../forms/FormField/FormField';
import submitForm from '../../../../services/submitCvForm';
import Navigation from '../Navigation';

const validationSchema = yup.object({
    name: yup.string().required('Please enter your name.'),
    phone: yup.string().required('Please enter your phone number.'),
    email: yup.string().email('Invalid email address.').required('Please enter your email address.'),
    role: yup.string().required('Please let us know the type of role you wish to apply for.'),
    salary: yup.string().required('Please enter your salary expectation.'),
    notice: yup.string().required('Please enter your notice period'),
    location: yup.string().required('Please tell us where you\'re based.'),
    docs: yup.array()
        .min(1, 'You must upload at least one document.')
        .test('fileSize', 'File(s) must be less than 8MB.', value => {
            let valid = true;
            value?.forEach(file => {
                if (file.size > 8 * 1024 * 1024) {
                    valid = false;
                }
            });
            return valid;
        })
        .test('fileType', 'Unsupported file type, only PDFs and word documents are accepted.', value => {
            const supportedTypes = ['application/pdf', 'application/rtf', 'text/plain', 'application/vnd.oasis.opendocument.text', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
            let valid = true;
            value?.forEach(file => {
                if (!supportedTypes.includes(file.type)) {
                    valid = false;
                }
            });
            return valid;
        })
});


export default function CvForm({ setJourney }) {
    const [loading, setLoading] = useState(false);
    const formik = useFormik({
        initialValues: {
            docs: [],
            name: '',
            phone: '',
            email: '',
            role: '',
            salary: '',
            notice: '',
            location: ''
        },
        validationSchema: validationSchema,
        onSubmit: values => submitForm(values, setJourney, setLoading),
    });

    return (
        <FormContainer>
            <form className={loading ? styles.loading : ""} onSubmit={formik.handleSubmit}>
                <h2>Submit your CV</h2>
                <FileUpload formik={formik} />
                <FormField label="Name:" type="text" name="name" formik={formik} />
                <FormField label="Phone:" type="text" name="phone" formik={formik} />
                <FormField label="Email:" type="email" name="email" formik={formik} />
                <FormField label="Desired role:" type="text" name="role" formik={formik} />
                <FormField label="Salary expectation:" type="text" name="salary" formik={formik} />
                <FormField label="Notice period:" type="text" name="notice" formik={formik} />
                <FormField label="Location:" type="text" name="location" formik={formik} />
                <Navigation setJourney={setJourney} formik={formik} />
            </form>
        </FormContainer>
    )
}
